import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { MouseWithin, IMouseWithinStatus } from "azure-devops-ui/MouseWithin";

export default class MouseWithinExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div className="flex-column">
                <MouseWithin>
                    {(MouseStatus: IMouseWithinStatus) => (
                        <div
                            className="flex-column"
                            style={{
                                border: MouseStatus.hasMouse ? "1px solid blue" : "1px solid black"
                            }}
                        >
                            <div
                                style={{ padding: "8px" }}
                                onMouseEnter={MouseStatus.onMouseEnter}
                                onMouseLeave={MouseStatus.onMouseLeave}
                            >
                                <Button text="Button1" />
                            </div>
                            <div
                                style={{ padding: "8px" }}
                                onMouseEnter={MouseStatus.onMouseEnter}
                                onMouseLeave={MouseStatus.onMouseLeave}
                            >
                                <Button text="Button2" />
                            </div>
                            <div
                                style={{ padding: "8px" }}
                                onMouseEnter={MouseStatus.onMouseEnter}
                                onMouseLeave={MouseStatus.onMouseLeave}
                            >
                                <Button text="Button3" />
                            </div>
                        </div>
                    )}
                </MouseWithin>
            </div>
        );
    }
}
